import BulkSpecialtiesTab from './BulkSpecialtiesTab';

export default BulkSpecialtiesTab;
